<template>
  <el-dialog
    :title="title"
    :visible="is_visible"
    width="560px"
    @close="closeDialog"
  >
    <div v-loading="loading">
      <MultilineInput
        v-if="metaData.panels"
        v-model="UTMList"
        :field="this.field"
        :options="filteredOptions"
        @load-options="loadOptions"
      />
    </div>
    <div slot="footer">
      <div class="footer" v-if="metaData.buttons_menu">
        <FormButtons
          v-for="item in metaData.buttons_menu[0]"
          :key="item.id"
          :buttons_menu="[[item]]"
          :topPanel="false"
          :loading="loading"
          breakOnSave
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { store } from '@/store';
import { eventBus } from '@/bus';
import { getController, postController } from '@/controllers/request';
import { Dialog } from 'element-ui';
import { errorMsg } from '@/utils/mixins'
import { MODULE, ACTION, EVENTBUS_EVENTS } from '@/utils/constants';
import MultilineInput from 'Elements/MultilineInput/MultilineInput.vue';
import FormButtons from 'Elements/Form/FormButtons';
export default {
  mixins: [errorMsg],
  data() {
    return {
      title: 'Добавление новых UTM-меток из справочника',
      UTMList: [],
      metaData: {},
      filteredOptions: [],
      field: null,
    };
  },
  props: {
    is_visible: {
      type: Boolean
    }
  },
  created() {
    this.setLoading(true);
    const params = {
      module: MODULE.HRPAC_PUBLISHED_VACANCY,
      action: ACTION.GET_ADD_UTM_REL_POPUP,
      record: this.currentVacancy.id.value,
      to_pdf: true
    };

    getController({ params }).then(res => {
      this.metaData = res.data.metadata;
      this.field = this.metaData.panels[0].rows[0][0];
      this.setLoading(false);
    });

    eventBus.$on(EVENTBUS_EVENTS.SAVEFORM, this.saveForm);
    eventBus.$on(EVENTBUS_EVENTS.CLOSE_POPUP, this.closeDialog);
  },
  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.SAVEFORM);
    eventBus.$off(EVENTBUS_EVENTS.CLOSE_POPUP);
  },
  methods: {
    saveForm(intents) {
      const newUTMList = [];
      this.UTMList.forEach(({ value }) => {
        if (value) newUTMList.push(value);
      })

      if (!newUTMList.length) {
        this.closeDialog();
        return;
      }

      this.setLoading(true);
      const { url, request_params } = intents[0].request;

      const formData = new FormData();
      Object.entries(request_params).forEach(([key, value]) => {
        formData.append(key, value);
      });
      newUTMList.forEach(value => {
        formData.append('drt_utm_id[]', value);
      });
      
      postController({ url, options: formData }).then(res => {
        this.setLoading(false);
        const { status, message, error } = res.data;
        if (status == 'success') {
          if (message) {
            this.showNotification({
              message: res.data.message,
              type: 'success',
              showClose: false
            });
          }
          this.closeDialog();
        } else if (status == 'error') {
          this.showNotification({
            message: error.error_text.error,
            type: 'error',
            showClose: false
          });
        }
      });
    },
    loadOptions(url, searchString, loadMore = false) {
      const params = {
        search_string: searchString,
        offset: loadMore ? this.options.length : 0,
      };
      getController({ url, params }).then(res => {
        if (typeof res.data === 'object') {
          const options = loadMore ? this.options : [];
          options.push(...this.getOptionsFromResponse(res.data));
          store.commit('common/setNewOptions', {
            name: this.field.name,
            val: options
          });
          this.filteredOptions = this.filterOptions(this.options)
        }
      });
    },
    closeDialog() {
      store.commit('publicator/setSelectedPublishedVacancy', null);
      store.commit('common/setVisibleDialog', {
        name: 'publicator_utm_binding_dialog',
        val: false
      });
    },
    setLoading(value) {
      store.commit('dialog/setLoading', value);
    },
    getOptionsFromResponse(dict) {
      return Object.entries(dict)
        .map(([key, value]) => ({ id: key, name: value }));
    },
    filterOptions(options) {
      return options
        .filter(({ id }) => !this.UTMList
          .some(({ value }) => value == id)
        )
    }
  },
  computed: {
    currentVacancy() {
      return store.state.publicator.selectedPublishedVacancy;
    },
    loading() {
      return store.state.dialog.loading;
    },
    options() {
      return store.state.common.newOptions[this.field?.name] || [];
    }
  },
  components: {
    'el-dialog': Dialog,
    MultilineInput,
    FormButtons
  }
};
</script>
<style lang="scss" scoped></style>
